import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    runQuiz: 'Start quiz',
    runQuizReasoning: 'Starting quiz',
    runQuizOutput: 'Started quiz',
    runQuizError: 'Error running quiz',
    presentQuizResult: 'Present quiz result',
    presentQuizResultReasoning: 'Presenting quiz result',
    presentQuizResultOutput: 'Presented quiz result',
    presentQuizResultError: 'Error presenting quiz result',
    getQuizResult: 'Get quiz result',
    getQuizResultReasoning: 'Getting quiz result',
    getQuizResultOutput: 'Got quiz result',
    getQuizResultError: 'Error getting quiz result',
    listLifeDomainQuizResults: 'List life domain quiz results',
    listLifeDomainQuizResultsReasoning: 'Listing life domain quiz results',
    listLifeDomainQuizResultsOutput: 'Listed life domain quiz results',
    listLifeDomainQuizResultsError: 'Error listing life domain quiz results',
    listLifeDomainQuizResultsNoop: 'No quiz results found',
  });
  i18next.addResourceBundle('en', 'quiz', {
    group_uvilo360: 'Uvilo 360',
    group_uvilo_onb: 'Onboarding',
    group_program: 'Program',
  });
}
